import { EditOutlined } from "@ant-design/icons";
import { ReviewStatus } from "__legacy/queries/__generated__/globalTypes";
import { CandidaciesQueryProvider } from "__legacy/queries/candidacies/CandidaciesQueryProvider";
import { ReviewStatusesQuery_reviewStatuses_enumValues } from "__legacy/queries/enums/__generated__/ReviewStatusesQuery";
import { ReviewStatusesQueryProvider } from "__legacy/queries/enums/ReviewStatusesQueryProvider";
import { Button, Input, Layout, PageHeader, Table, Tabs } from "antd";
import { find } from "lodash";
import moment from "moment";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [activePane, setActivePane] = useState<ReviewStatus>();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const columns = (reviewStatuses: ReviewStatusesQuery_reviewStatuses_enumValues[]) => [
    {
      title: "Status",
      dataIndex: "status",
      render: (value: string, resource: any) => find(reviewStatuses, ({ name }) => name === value)?.description,
    },
    {
      title: "Auditor",
      render: (value: string, resource: any) => `${resource.ability.stakeholder.companyName}`,
    },
    {
      title: "Agency",
      render: (value: string, resource: any) => resource.ability.stakeholder.agency.name,
    },
    {
      title: "Scheme",
      render: (value: string, resource: any) => resource.ability.scheme.name,
    },
    {
      title: "Application Date",
      dataIndex: "insertedAt",
      render: (value: string, resource: any) => moment(value).format("MM-DD-YYYY"),
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Button onClick={() => navigate(`${id}/review`)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <CandidaciesQueryProvider
      variables={{ applicationsOnly: true, status: activePane, search: searchQuery, filterAuthorities: true }}
    >
      {({ candidacies }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Code Applications"
            extra={
              <Input.Search
                allowClear
                placeholder="search"
                onSearch={handleSearch}
                defaultValue={searchQuery ?? ""}
                style={{ width: 500 }}
              />
            }
            footer={
              <Tabs
                activeKey={activePane}
                onChange={(activeKey: any) => setActivePane(activeKey !== "all" ? activeKey : undefined)}
              >
                <Tabs.TabPane tab="All" key="all" />
                <Tabs.TabPane tab="For Review" key="for_review" />
                <Tabs.TabPane tab="Need Correction" key="need_correction" />
              </Tabs>
            }
          />
          <Layout.Content className="content">
            <ReviewStatusesQueryProvider>
              {({ reviewStatuses }) => (
                <Table
                  rowKey="id"
                  columns={columns(reviewStatuses?.enumValues ?? [])}
                  dataSource={candidacies}
                  pagination={false}
                />
              )}
            </ReviewStatusesQueryProvider>
          </Layout.Content>
        </Fragment>
      )}
    </CandidaciesQueryProvider>
  );
};
